import { FilterSearchingBaseViewModel, PagingResultsViewModel } from '../../../core/_infrastructure/types/common';

export class RestriccionProductosExViewModel {
    public IdEspecie: number;
    public IdPaisDestino: number;
    public IdGrupo: number | null;
    public IdGrupoDescripcion = '';
    public IdForma: number | null;
    public IdFormaDescripcion = '';
    public CodigoEppo = '';
    public NombreCientifico = '';
    public NombreComun = '';
    public FechaCreacion: Date;
    public FechaBaja: Date;
    public Activa = false;
}

export class RestriccionProductosExItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: RestriccionProductosExItemViewModel[];
}

export class RestriccionProductosExItemViewModel {
    public IdEspecie: number;
    public IdPaisDestino: number;
    public IdPaisDestinoDescripcion = '';
    public IdGrupo: number | null;
    public IdGrupoDescripcion = '';
    public IdForma: number | null;
    public IdFormaDescripcion = '';
    public CodigoEppo = '';
    public NombreCientifico = '';
    public NombreComun = '';
    public FechaCreacion: Date;
    public Activa = false;
}

export class FilterSearchingRestriccionProductosExViewModel extends FilterSearchingBaseViewModel {
    public IdEspecie: number;
    public IdPaisDestino: number;
    public IdGrupo: number | null;
    public IdForma: number | null;
    public CodigoEppo = '';
    public NombreCientifico = '';
    public NombreComun = '';
    public Activa = false;
}
